export default __webpack_public_path__ + "static/media/CMS_ChargeZone.b5592c66.svg";